module.exports = __webpack_public_path__ + "img/icon_sec6_01.2611d754.png";